import { deriveAccentPalette } from "@pack-it-up/ui-web";
import { LOGO_MARK_PATH } from "./icons.js";

const DEFAULT_HREF = "/icon.svg";

const buildFaviconDataUri = (accentColor: string): string => {
  const { accent, accentText } = deriveAccentPalette(accentColor);
  const svg =
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">` +
    `<rect width="512" height="512" rx="96" fill="${accent}"/>` +
    `<path fill="${accentText}" fill-rule="evenodd" d="${LOGO_MARK_PATH}"/>` +
    `</svg>`;
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
};

// The static /icon.svg (baked amber) can't follow a user's chosen accent, so once one is
// picked we swap the tab favicon for a matching data-URI SVG built from the same
// suitcase glyph. Reverts to the static file when the user resets to the default.
export const applyFaviconAccent = (accentColor: string | null): void => {
  const link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (link === null) return;
  link.href = accentColor === null ? DEFAULT_HREF : buildFaviconDataUri(accentColor);
};
